<script lang="ts" setup>
import { useModal } from 'vue-final-modal'

import BasicButton from '~/components/form-elements/BasicButton.vue'
import LeftSideMenu from '~/components/menus/LeftSideMenu.vue'
import Auth from '~/components/modal-windows/Auth.vue'
import SupplierRegistration from '~/components/modal-windows/supplier/SupplierRegistration.vue'
import menuItems from '~/constants/menu-items'
import AuthAction from '~/enums/auth-action'
import Page from '~/enums/page'
import { useAuthStore } from '~/store/auth'
import { useUserStore } from '~/store/user'
import type { BreadcrumbsItem } from '~/types/breadcrumbs'

const props = withDefaults(
  defineProps<{
    isMainPage?: boolean
    title: string
  }>(),
  { isMainPage: false }
)

const authStore = useAuthStore()
const userStore = useUserStore()

const isDataLoading = ref(true)

const breadcrumbsItems = computed(() => {
  const items: BreadcrumbsItem[] = [{ name: 'Главная', path: Page.Main }]

  if (!props.isMainPage) {
    items.push({ name: 'ЛК поставщика', path: Page.Supplier })
  }

  return items
})

onMounted(() => {
  isDataLoading.value = false
})

async function openAuthModalWindow (): Promise<void> {
  await useModal({ component: Auth, attrs: { action: AuthAction.SignIn } }).open()
}

async function openSupplierRegistrationModalWindow (): Promise<void> {
  await useModal({ component: SupplierRegistration }).open()
}
</script>

<template>
  <section>
    <div class="container">
      <Breadcrumbs :current="title" :items="breadcrumbsItems" />

      <Preloader v-if="isDataLoading" />
      <template v-else-if="authStore.isUser">
        <template v-if="userStore.isSupplier">
          <div class="row">
            <div class="column-2 tb12 with-margin-bottom">
              <LeftSideMenu :items="menuItems.supplier" />
            </div>
            <div class="column-10 tb12 with-margin-bottom">
              <div class="content-wrapper">
                <slot />
              </div>
            </div>
          </div>
        </template>
        <div v-else class="content-wrapper">
          <h1>{{ title }}</h1>

          <Notification class="mb-6" status="info">
            Добро пожаловать! <a
              href="#"
              @click.prevent="openSupplierRegistrationModalWindow"
            >Заполните</a> сведения о&nbsp;компании и&nbsp;контактном лице.
          </Notification>

          <BasicButton color="green" is-small title="Заполнить" @click="openSupplierRegistrationModalWindow" />
        </div>
      </template>
      <div v-else class="content-wrapper">
        <h1>{{ title }}</h1>

        <Notification class="mb-6" status="info">
          Чтобы стать поставщиком или воспользоваться ЛК поставщика, <a
            href="#"
            @click.prevent="openAuthModalWindow"
          >войдите</a>.
        </Notification>

        <BasicButton color="green" is-small title="Войти" @click="openAuthModalWindow" />
      </div>
    </div>
  </section>
</template>
